"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logDeprecationNote = void 0;
const logDeprecationNote = (message) => {
    if (process.env.NODE_ENV !== 'production') {
        console.warn(`[DEPRECATION NOTE] ${message}`);
    }
};
exports.logDeprecationNote = logDeprecationNote;
//# sourceMappingURL=logDeprecationNote.js.map